import mixpanel from 'mixpanel-browser';

import useCommonProperties from './useCommonProperties.js';

/**
 * Reports a tracked event to mixpanel using common properties
 * @param {string} eventName - The name of the event to track (should be a config constant)
 * @param {string} label - The label of the event to track
 * @param {object} data - The data to track
 * @param {boolean} sendImmediately - Whether to send the event immediately or wait for the next flush
 */
const useTrackEvent = ({ eventName, label, data = {}, sendImmediately = false }) => {
  // NOTE: Currently we aren't tracking any frontend post-sign in events other than
  // when they first sign up - which they don't have an org at that point.
  // If this changes, we would want to automatically add the org id
  // of the current org here, like we do in the backend

  mixpanel.disguise.track(
    eventName,
    {
      ...data,
      ...useCommonProperties(label),
    },
    {
      send_immediately: sendImmediately,
    }
  );
};

export default useTrackEvent;
